// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './config/router'
import VueQuillEditor from 'vue-quill-editor'
import 'assets/less/base.less'
import 'assets/less/layout.less'
// 给window扩展utils属性
import * as utils from 'src/utils'
window.utils === undefined && (window.utils = utils)

// 高德地图
import AMap from 'vue-amap'
Vue.use(AMap)

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德的key
  key: '28966b6be8e4fa0e4c4f4c9b4bf8d3ce',
  // 插件集合
  plugin: ['Autocomplete', 'PlaceSearch', 'AMap.Geolocation']
})

// quill-editor富文本编辑器
Vue.use(VueQuillEditor)

// element components
import { Button, ButtonGroup, Input, Form, Badge, FormItem, Select, Upload, Option, Row, Col, Rate, Loading, Dialog, Icon, Tabs, TabPane, Pagination, Table, tableColumn, Checkbox, Menu, MenuItem, Dropdown, DropdownMenu, DropdownItem, Tag, DatePicker, CheckboxGroup, Tree, Autocomplete, Radio, RadioGroup, RadioButton, Tooltip, Steps, Step, inputNumber, Switch, TimePicker, TimeSelect, Scrollbar, Cascader, Progress, Carousel, CarouselItem, Popover, Collapse, CollapseItem, OptionGroup, Transfer, Breadcrumb, BreadcrumbItem } from 'element-ui'

// 增加一个全局过滤器
Vue.filter('thumbnail', function (imgUrl, size) {
  // 判断imgURL格式
  if (!imgUrl || typeof imgUrl !== 'string') {
    return imgUrl
  } else {
    imgUrl = imgUrl.replace(/\?\d+$/, '') // 兼容老数据
  }
  // 判断size是否有效
  if ([40, 50, 80, 100].indexOf(size) === -1) {
    size = 100
  }
  return `${imgUrl}_${size}x${size}.jpg`
})

// element尺寸全局配置
Vue.prototype.$ELEMENT = { size: 'small' }
Vue.use(Button)
Vue.use(Badge)
Vue.use(ButtonGroup)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Rate)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Table)
Vue.use(tableColumn)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tag)
Vue.use(DatePicker)
Vue.use(CheckboxGroup)
Vue.use(Upload)
Vue.use(Tree)
Vue.use(Autocomplete)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Tooltip)
Vue.use(Steps)
Vue.use(Step)
Vue.use(inputNumber)
Vue.use(Switch)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Scrollbar)
Vue.use(Cascader)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Popover)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(OptionGroup)
Vue.use(Transfer)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js